export default __webpack_public_path__ + "static/media/nitya_sharma.e7da5f3a.jpg";